import { Filters, ViewData } from './components';
import { Separator } from '@/components/ui';
import { HeaderPage } from '../components';

const PaymentMethodRequestsPage = () => (
	<div className='flex flex-col space-y-6'>
		<HeaderPage
			title='Demandes de moyens de paiement'
			description='Moyens de paiement demandés par les utilisateurs.' />
		<div className='flex flex-col space-y-3'>
			<Filters />
			<Separator className='bg-muted' />
			<ViewData />
		</div>
	</div>
);

export default PaymentMethodRequestsPage;
